/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { LocationUrls } from "./LocationUrls";

export const SCREEN_DISPLAY_NAMES = {
  SPLASH: "Splash",
  SIGN_IN: "Sign In",
  HOME: "Home",
  GUIDE: "Guide",
  SELECT_PROFILE: "Select Profile",
  CONTENT_DETAIL: "Content Detail",
  MY_HUB: "My Hub",
  SPORTS_HUB: "Sports Hub",
  SHOWS_AND_MOVIES: "Shows & Movies",
  SEARCH: "Search",
  SETTINGS: "Settings"
} as const;

/**
 * Maps every known URL path to a human-readable screen name for analytics
 * (`scr` field). Sibling to `urlToScreenName` (ScreenController identifiers) —
 * this map exists solely for display purposes.
 */
const URL_TO_SCREEN_DISPLAY_NAME: Readonly<Record<string, string>> = {
  [LocationUrls.SPLASH]: SCREEN_DISPLAY_NAMES.SPLASH,
  [LocationUrls.SIGN_IN]: SCREEN_DISPLAY_NAMES.SIGN_IN,
  [LocationUrls.HOME_SCREEN]: SCREEN_DISPLAY_NAMES.HOME,
  [LocationUrls.GUIDE]: SCREEN_DISPLAY_NAMES.GUIDE,
  [LocationUrls.SELECT_PROFILE]: SCREEN_DISPLAY_NAMES.SELECT_PROFILE,
  [LocationUrls.CONTENT_DETAIL]: SCREEN_DISPLAY_NAMES.CONTENT_DETAIL,
  [LocationUrls.MY_HUB]: SCREEN_DISPLAY_NAMES.MY_HUB,
  [LocationUrls.SPORTS_HUB]: SCREEN_DISPLAY_NAMES.SPORTS_HUB,
  [LocationUrls.SHOWS_AND_MOVIES]: SCREEN_DISPLAY_NAMES.SHOWS_AND_MOVIES,
  [LocationUrls.SEARCH]: SCREEN_DISPLAY_NAMES.SEARCH,
  [LocationUrls.SETTINGS]: SCREEN_DISPLAY_NAMES.SETTINGS
};

/**
 * Returns the human-readable screen name for the given URL path.
 * Returns an empty string if the URL has no registered display name.
 *
 * @param url - An absolute pathname such as "/home" or "/search".
 */
export function urlToScreenDisplayName(url: string): string {
  const name: string | undefined = URL_TO_SCREEN_DISPLAY_NAME[url];
  return name !== undefined ? name : "";
}
